import type { HeavenlyStem } from '../types/stems';
import type { Relation } from '../types/relations';
import type { PillarPosition } from '../types/pillars';
import { stemIndex } from '../core/sexagenary';
import { isAdjacentPillar } from './adjacent';

// 천간충 pairs: index difference of 6 for stems 0-3 vs 6-9
// 甲(0)↔庚(6), 乙(1)↔辛(7), 丙(2)↔壬(8), 丁(3)↔癸(9)
// 戊(4) and 己(5) do not have 천간충 traditionally
// 인접 기둥(연-월, 월-일, 일-시)에서만 충 발생
export const CLASH_PAIRS: [number, number][] = [
  [0, 6], // 甲↔庚
  [1, 7], // 乙↔辛
  [2, 8], // 丙↔壬
  [3, 9], // 丁↔癸
];

export function findHeavenlyClashes(
  stems: { stem: HeavenlyStem; position: PillarPosition }[]
): Relation[] {
  const relations: Relation[] = [];

  for (let i = 0; i < stems.length; i++) {
    for (let j = i + 1; j < stems.length; j++) {
      if (!isAdjacentPillar(stems[i].position, stems[j].position)) continue;
      const a = stemIndex(stems[i].stem);
      const b = stemIndex(stems[j].stem);

      for (const [s1, s2] of CLASH_PAIRS) {
        if ((a === s1 && b === s2) || (a === s2 && b === s1)) {
          const [first, second] = a === s1 ? [stems[i], stems[j]] : [stems[j], stems[i]];
          relations.push({
            type: '천간충',
            pillars: [stems[i].position, stems[j].position],
            stems: [first.stem, second.stem],
            description: `${first.stem}${second.stem}충`,
          });
        }
      }
    }
  }

  return relations;
}
